import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import './landing.css'
import './i18n' // Initialize i18n

// Font Awesome setup
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUpload,
  faPlus,
  faTrash,
  faCopy,
  faDownload,
  faSignature,
  faCheck,
  faXmark,
  faSpinner,
  faEye,
  faLink,
  faFileExcel,
  faFilePdf,
  faLock,
  faArrowLeft,
  faEraser,
  faUser,
  faCreditCard,
  faArrowRightFromBracket,
  faCrown,
  faPen,
  faFile,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUpload,
  faPlus,
  faTrash,
  faCopy,
  faDownload,
  faSignature,
  faCheck,
  faXmark,
  faSpinner,
  faEye,
  faLink,
  faFileExcel,
  faFilePdf,
  faLock,
  faArrowLeft,
  faEraser,
  faUser,
  faCreditCard,
  faArrowRightFromBracket,
  faCrown,
  faPen,
  faFile,
  faArrowRight
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
